import { Text } from "@/components/ui/baseUi/text"
import { BoxProgramVisibility } from "@/modules/boxProgrammation/boxProgramTypes"
import { type BoxProgramColorType, boxProgramColors } from "@/modules/boxProgrammation/components/boxProgramColors"
import { word } from "@modules/core/utils/i18n"

export const DEFAULT_BOX_PROGRAMMATION_COLOR: BoxProgramColorType = "blue500"

export const getBoxProgrammationColorName = (type: BoxProgramColorType) => {
  switch (type) {
    case "purple500":
      return word("programmation.color.purple500")
    case "purple200":
      return word("programmation.color.purple200")
    case "blue500":
      return word("programmation.color.blue500")
    case "blue200":
      return word("programmation.color.blue200")
    case "green500":
      return word("programmation.color.green500")
    case "green200":
      return word("programmation.color.green200")
    case "yellow500":
      return word("programmation.color.yellow500")
    case "yellow200":
      return word("programmation.color.yellow200")
    case "orange500":
      return word("programmation.color.orange500")
    case "orange200":
      return word("programmation.color.orange200")
  }
}

const BoxProgrammationColorByHex = Object.entries(boxProgramColors).reduce<Record<string, BoxProgramColorType>>(
  (acc, [key, value]) => {
    acc[value.background] = key as BoxProgramColorType
    return acc
  },
  {},
)

export const getBoxProgramColorTypeWithHex = (hex: string): BoxProgramColorType => {
  return BoxProgrammationColorByHex[hex] ?? DEFAULT_BOX_PROGRAMMATION_COLOR
}

export const getBoxProgrammationVisibilityName = (visibility: BoxProgramVisibility) => {
  switch (visibility) {
    case BoxProgramVisibility.MEMBERS:
      return word("box.programmation.form.access.standard.label")
    case BoxProgramVisibility.PRIVATE:
      return word("box.programmation.form.access.private.label")
    case BoxProgramVisibility.PUBLIC:
      return word("box.programmation.form.access.public.label")
  }
}

export const getBoxProgrammationVisibilityExplanation = (visibility: BoxProgramVisibility) => {
  switch (visibility) {
    case BoxProgramVisibility.MEMBERS:
      return (
        <div className="flex w-full flex-col justify-between gap-4">
          <Text fontStyle="BS">{word("box.programmation.form.access.standard.explanation1")}</Text>
          <Text fontStyle="BS">{word("box.programmation.form.access.standard.explanation2")}</Text>
        </div>
      )
    case BoxProgramVisibility.PRIVATE:
      return (
        <div className="flex w-full flex-col justify-between gap-4">
          <Text fontStyle="BS" className="text-center">
            {word("box.programmation.form.access.private.explanation")}
          </Text>
        </div>
      )

    case BoxProgramVisibility.PUBLIC:
      return (
        <div className="flex w-full flex-col justify-between gap-4">
          <Text fontStyle="BS" className="text-center">
            {word("box.programmation.form.access.public.explanation")}
          </Text>
        </div>
      )
  }
}
